export const presetRegimenTags = [
  {
    name: 'acne',
    value: 'Acne',
    type: 'logic'
  },
  {
    name: 'hands',
    value: 'Hands',
    type: 'custom'
  },
  {
    name: 'post_procedure',
    value: 'Post Procedure',
    type: 'custom'
  },
  {
    name: 'body',
    value: 'Body',
    type: 'custom'
  },
  {
    name: 'lips',
    value: 'Lips',
    type: 'custom'
  },
  {
    name: 'pre_procedure',
    value: 'Pre Procedure',
    type: 'custom'
  },
  {
    name: 'dark_circles',
    value: 'Dark Circles',
    type: 'custom'
  },
  {
    name: 'dryness',
    value: 'Dryness',
    type: 'logic'
  },
  {
    name: 'radiance_texture',
    value: 'Radiance + Texture',
    type: 'custom'
  },
  {
    name: 'eye_concerns',
    value: 'Eye Concerns',
    type: 'custom'
  },
  {
    name: 'neck_decolette',
    value: 'Neck + Décolleté',
    type: 'custom'
  },
  {
    name: 'redness',
    value: 'Redness',
    type: 'logic'
  },
  {
    name: 'firmness_wrinkles',
    value: 'Firmness + Wrinkles',
    type: 'logic'
  },
  {
    name: 'oiliness_pores',
    value: 'Oiliness + Pores',
    type: 'logic'
  },
  {
    name: 'discoloration',
    value: 'Discoloration',
    type: 'logic'
  }
];